'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _xodProject = require('xod-project');

var XP = _interopRequireWildcard(_xodProject);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// :: Patch -> [String]
const generateKeywords = R.compose(R.reject(R.equals('to')), R.split('-'), XP.getBaseName, XP.getPatchPath);

// :: Patch -> String
const getFullDescription = R.compose(R.propOr('', 'content'), R.find(R.propEq('filename', 'README.md')), XP.getPatchAttachments);

// :: [Patch] -> [{ path: String, keywords: [String], desription: String, fullDescription: string }]
exports.default = R.map(R.applySpec({
  path: XP.getPatchPath,
  lib: R.compose(XP.getLibraryName, XP.getPatchPath),
  keywords: generateKeywords,
  description: XP.getPatchDescription,
  fullDescription: getFullDescription
}));


//////////////////
// WEBPACK FOOTER
// ../xod-patch-search/dist/mapper.js
// module id = 1505
// module chunks = 0